<template>
  <sidebar-item>
    <form @submit.prevent="onFormSubmitted">
      <h2 v-translate>Zdroj: Originální data</h2>
      <item-move-everything
        name="move_all_original_data"
        :checked="isMainCheckboxChecked"
        @change="onMainCheckboxChanged"
      />
      <item-checkbox-input
        v-for="key in Object.keys(checkboxes)"
        :key="key"
        :name="key"
        :title="checkboxes[key].title"
        :value="checkboxes[key].value"
        :checked="checkboxes[key].checked"
        @change="onCheckboxChanged(key, $event)"
      />
    </form>
  </sidebar-item>
</template>

<script>
import { AUTOCOMPLETE_TITLE } from 'symbols/autocomplete'
import SidebarItem from '../Common/Sidebar/SidebarItem'
import ItemMoveEverything from './ItemMoveEverything'
import ItemCheckboxInput from './ItemCheckboxInput'
import { mapState } from 'vuex'

export default {
  name: 'item-original-source',
  components: {
    ItemCheckboxInput,
    ItemMoveEverything,
    SidebarItem
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mockData: [
        {
          id: 1,
          name: 'Hmongové a jejich koně',
          type: 'Dokument',
          year: '2010'
        },
        {
          id: 2,
          name: 'Jejich oči sledovaly boha',
          type: 'Dokument',
          year: '2004'
        },
        {
          id: 3,
          name: 'Naši němci a jejich češi',
          type: 'Dokument',
          year: '2011'
        }
      ],
      checkboxesValue: {
        name: false,
        year: false,
        formatLabel: false,
        contentLabels: false,
        descriptionShort: false,
        description: false
      }
    }
  },
  computed: {
    ...mapState({
      labels: state => state.labels.labels
    }),
    autocompleteSource() {
      return this.mockData.map(item => ({
        ...item,
        [AUTOCOMPLETE_TITLE]: `${item.name} (${item.type}${item.year ? ', ' : ''}${item.year || ''})`
      }))
    },
    isMainCheckboxChecked() {
      return Object.keys(this.checkboxes).every(v => this.checkboxes[v].checked)
    },
    checkboxes() {
      return {
        name: {
          title: this.$gettext('Název'),
          value: String(this.item.name || ''),
          checked: this.checkboxesValue.name
        },
        year: {
          title: this.$gettext('Rok'),
          value: String(this.item.year || ''),
          checked: this.checkboxesValue.year
        },
        formatLabel: {
          title: this.$gettext('Formátový štítek'),
          value: String(this.getLabelName(this.item.formatLabelId) || ''),
          checked: this.checkboxesValue.formatLabel
        },
        contentLabels: {
          title: this.$gettext('Obsahové štítky'),
          value: String(this.getLabelNames(this.item.contentLabelIds) || ''),
          checked: this.checkboxesValue.contentLabels
        },
        descriptionShort: {
          title: this.$gettext('Popis krátký'),
          value: String(this.item.descriptionShort || ''),
          checked: this.checkboxesValue.descriptionShort
        },
        description: {
          title: this.$gettext('Popis dlouhý'),
          value: String(this.item.descriptionLong || ''),
          checked: this.checkboxesValue.description
        }
      }
    }
  },
  methods: {
    onCheckboxChanged(name, checked) {
      this.checkboxes[name].checked = checked
    },
    onMainCheckboxChanged(checked) {
      Object.keys(this.checkboxesValue).forEach(v => {
        this.checkboxesValue[v] = checked
      })
    },
    onFormSubmitted() {
      this.$emit('submit', this.checkboxes)
    },
    getLabelName(id) {
      if (id) {
        for (const key in this.labels) {
          if (id == this.labels[key]._id) {
            return this.labels[key].labelName
          }
        }
      }

      return ''
    },
    getLabelNames(ids) {
      if (ids && ids.length > 0) {
        const labelNames = []
        for (const key1 in this.labels) {
          for (const key2 in ids) {
            if (ids[key2] == this.labels[key1]._id) {
              labelNames.push(this.labels[key1].labelName)
            }
          }
        }

        return labelNames.join(',')
      }

      return ''
    }
  }
}
</script>
